import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import { GridInputs } from "../../../../../components/Functional";
import { FETCH_JOB_STATUSES } from "../../../../../graphql/query/JobStatus";
import { useEntities } from "../../../../../hooks/useEntities";

const getHandoverInputs = ({ entityOptions, jobStatuses } = {}) => ({
  className: "grid grid-rows-2 gap-4",
  inputs: [
    {
      className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
      inputs: [
        {
          type: "label",
          name: "_CRMRegistrar.typeId",
          className: "hidden",
        },
        {
          label: "Date Start",
          name: "_CRMRegistrar.date.value.from",
          type: "date",
        },
        {
          label: "Date End",
          name: "_CRMRegistrar.date.value.to",
          type: "date",
        },
        {
          label: "Handover From",
          name: "_CRMRegistrar.salesUserId",
          options: entityOptions,
          type: "multi-select",
        },
        {
          label: "Handover To",
          name: "_CRMRegistrar.userId",
          options: entityOptions,
          type: "multi-select",
        },
      ],
    },
    {
      className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
      inputs: [
        {
          label: "Notes",
          name: "_CRMRegistrar.notes",
          type: "text",
        },
        {
          label: "Status",
          name: "_CRMRegistrar.statusId",
          options: jobStatuses?.map(item => ({
            label: item?.description,
            value: item?.id,
          })),
          type: "multi-select",
        },
      ],
    },
  ],
});

const Handover = (props = {}) => {
  const { formik } = props;
  const { entities } = useEntities();
  const { data: { jobStatuses = [] } = {} } = useQuery(FETCH_JOB_STATUSES);
  const entityOptions = entities?.edges?.map(item => {
    return { label: item.name, value: item.id };
  });

  useEffect(() => {
    const { tab, _CRMRegistrar } = formik.values;

    if (tab === "handover") {
      if (_CRMRegistrar?.salesUserId || _CRMRegistrar?.userId) {
        formik.setFieldValue("_CRMRegistrar.typeId", 25);
      } else {
        formik.setFieldValue("_CRMRegistrar.typeId", undefined);
      }
    }
  }, [formik.values]);

  const inputs = getHandoverInputs({ entityOptions, jobStatuses });

  return <GridInputs formik={formik} {...inputs} />;
};

export default Handover;
export { getHandoverInputs };
